import React from 'react';
import PropTypes from 'prop-types';
import { OrderedMap, Set, Map } from 'immutable';

import PaypalBar from 'components/checkout/payment-information/new-payment-method/paypal-bar';
import BraintreeFields from 'components/payment-methods/payment-method-form/braintree-fields';
import SavePaymentMethod from 'components/checkout/payment-information/new-payment-method/save-payment-method';

import NewPaymentMethodModel from 'models/braintree/new-payment-method';
import PaymentMethodModel from 'models/payment-method';

const propTypes = {
  requiredFields: PropTypes.instanceOf(Set).isRequired,
  requiredFieldErrors: PropTypes.oneOfType([
    PropTypes.instanceOf(OrderedMap),
    PropTypes.instanceOf(Map),
  ]).isRequired,
  saveCreditCard: PropTypes.bool.isRequired,
  onFieldEvent: PropTypes.func.isRequired,
  setShouldScrollToError: PropTypes.func.isRequired,
  modifyRequiredFieldList: PropTypes.func.isRequired,

  newPaymentMethod: PropTypes.instanceOf(NewPaymentMethodModel),
  existingPaymentMethod: PropTypes.instanceOf(PaymentMethodModel),
  shouldScrollToError: PropTypes.bool,
  hideSaveToggle: PropTypes.bool,
  showNicknameField: PropTypes.bool,
  isPaypal: PropTypes.bool,
  creditCardFieldsClassNames: PropTypes.string,
  handlePaymentMethodSave: PropTypes.func,
  braintreeFieldStateChange: PropTypes.func,
  paypalEmail: PropTypes.string,
  showPaypal: PropTypes.bool,
  handlePaypalCancel: PropTypes.func,
  trackEvent: PropTypes.func,
};

const defaultProps = {
  isPaypal: false,
  creditCardFieldsClassNames: '',
  shouldScrollToError: false,
  hideSaveToggle: false,
  showNicknameField: false,
  newPaymentMethod: new NewPaymentMethodModel(),
  existingPaymentMethod: null,
  paypalEmail: null,
  showPaypal: true,
  handlePaymentMethodSave: () => {},
  braintreeFieldStateChange: () => {},
  handlePaypalCancel: () => {},
  trackEvent: () => {},
};

function cardType(newPaymentMethod, existingCardType) {
  if (newPaymentMethod && newPaymentMethod.card && newPaymentMethod.card.type) {
    return newPaymentMethod.card.type;
  }
  return existingCardType;
}

const PaymentMethodForm = ({
  existingPaymentMethod,
  newPaymentMethod,
  isPaypal,
  creditCardFieldsClassNames,
  onFieldEvent,
  saveCreditCard,
  handlePaymentMethodSave,
  requiredFields,
  requiredFieldErrors,
  shouldScrollToError,
  setShouldScrollToError,
  modifyRequiredFieldList,
  braintreeFieldStateChange,
  hideSaveToggle,
  showNicknameField,
  paypalEmail,
  handlePaypalCancel,
  showPaypal,
  trackEvent,
}) => (
  <div id="ccform" className="reducing-distractions">
    <input type="hidden" name="payment_method_nonce" id="payment_method_nonce" defaultValue="" />
    <PaypalBar
      card={cardType(newPaymentMethod, (existingPaymentMethod && existingPaymentMethod.paymentMethodType))}
      isPaypal={isPaypal}
      paypalEmail={paypalEmail}
      handlePaypalCancel={handlePaypalCancel}
      showPaypal={showPaypal}
      trackEvent={trackEvent}
    />
    <div id="credit-card-fields" className={creditCardFieldsClassNames}>
      <BraintreeFields
        existingPaymentMethod={existingPaymentMethod}
        onFieldEvent={onFieldEvent}
        requiredFields={requiredFields}
        requiredFieldErrors={requiredFieldErrors}
        shouldScrollToError={shouldScrollToError}
        setShouldScrollToError={setShouldScrollToError}
        modifyRequiredFieldList={modifyRequiredFieldList}
        braintreeFieldStateChange={braintreeFieldStateChange}
        showNicknameField={showNicknameField}
        trackEvent={trackEvent}
      />
      <SavePaymentMethod
        selected={saveCreditCard}
        onClick={handlePaymentMethodSave}
        hide={hideSaveToggle}
        trackEvent={trackEvent}
      />
    </div>
  </div>
);

PaymentMethodForm.propTypes = propTypes;
PaymentMethodForm.defaultProps = defaultProps;

export default PaymentMethodForm;
